<template>
  <saffron-link :to="{ name: 'store-deals-hot' }">
    <div
      class="floating-widget bg-lead c-text cta-block padding-m cursor-pointer flex flex-middle flex-center text-center text-2xl border-radius-sharp text-center">
      <icon-text icon="cart2">{{ t("justopp.deals.hotDealsButton") }}</icon-text>
    </div></saffron-link
  >
  <deals-view :filters="{ anyChildOf: 'root' }"></deals-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import DealsView from "@/client/applications/justopp/views/Deals.vue";

export default {
  components: {
    DealsView,
  },
  layout: {
    component: "default",
    params: {
      title: "justopp.deals.pageTitle",
      subTitle: "justopp.deals.pageSubtitle",
    },
  },
  middleware: {
   // requireUser: {},
  },
  props: {},
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.deals.browserTitle",
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.floating-widget {
  position: fixed;
  z-index: var(--z-top-1);
  top: calc(var(--margin-max) * 2.75);
  inset-inline-end: var(--margin-xl);
  opacity: 1;
  will-change: opacity;
  transition: opacity 150ms;

  @media (max-width: 1024px) {
    position: relative;
    top: auto;
    margin-inline: auto;
    width: 70%;
    font-size: var(--font-l);
    inset-inline-end: initial;
    margin-bottom: var(--margin-l);
    border: 1px solid var(--c-lead) !important;
    background-color: var(--c-bg) !important;
    color: var(--c-lead) !important;
    width: 100%;
    max-width: 400px;
  }

  &:hover {
    opacity: 0.8;
  }
}
</style>
